import * as FullCalendar from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';

import 'tippy.js/animations/scale.css';
import * as Model from '../model.js';
import appView from './appView.js';
import * as Database from './database.js';
import {
  FAILEDMESSAGE,
  EVENTSUCCESS,
  SUCCESSUPDATE,
  ITEMSDELETED,
} from '../config.js';

class CalendarApp extends appView {
  _newDate = new Date();
  _getModalTitleEl = document.querySelector('#event-title');
  _getModalStartDateEl = document.querySelector('#event-start-date');
  _getModalEndDateEl = document.querySelector('#event-end-date');
  _getModalUrlEl = document.querySelector('#event-url');
  _getModalAddBtnEl = document.querySelector('.btn-add-event');
  _getModalUpdateBtnEl = document.querySelector('.btn-update-event');
  _calendarEl = document.querySelector('.calendar');
  _myModal = new bootstrap.Modal(document.getElementById('exampleModal'));
  _calendarsEvents = {
    Work: 'primary',
    Personal: 'success',
    Important: 'danger',
    Travel: 'warning',
  };
  _calendarHeaderToolbar = {
    left: 'prev next addEventButton',
    center: 'title',
    right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek',
  };
  _calendarEventsList;
  _calendar;
  _currentPopover = null;

  constructor() {
    super();
    this.initialize();
  }

  async initialize() {
    await this._renderCalendarEvents();
    this._activateCalendar();
    this._addEvent();
    this._updateEvent();
    this._clearModalContent();
    this._calendar.render();
  }

  async _renderCalendarEvents() {
    try {
      this._calendarEventsList = await Database.getAllItemsFromDatabase(
        'event'
      );
    } catch (err) {
      self.failedMessageInfo(FAILEDMESSAGE);
    }
  }

  _getDynamicMonth() {
    const getMonthValue = this._newDate.getMonth();
    const getUpdatedMonthValue = getMonthValue + 1;
    if (getUpdatedMonthValue < 10) {
      return `0${getUpdatedMonthValue}`;
    } else {
      return `${getUpdatedMonthValue}`;
    }
  }

  _checkWidowWidth() {
    if (window.innerWidth <= 1199) {
      return true;
    } else {
      return false;
    }
  }

  _calendarSelect = info => {
    const getCheckedel = document.querySelector(`input[value="Work"]`);
    this._getModalAddBtnEl.style.display = 'block';
    this._getModalUpdateBtnEl.style.display = 'none';
    this._myModal.show();
    this._getModalStartDateEl.value = info.startStr + 'T00:00';
    this._getModalEndDateEl.value = info.endStr + 'T00:00';
    getCheckedel.checked = true;
  };

  _calendarAddEvent = () => {
    const currentDate = new Date();
    const dd = String(currentDate.getDate()).padStart(2, '0');
    const mm = String(currentDate.getMonth() + 1).padStart(2, '0');
    const hours = String(currentDate.getHours()).padStart(2, '0');
    const minutes = String(currentDate.getMinutes()).padStart(2, '0');
    const seconds = String(currentDate.getSeconds()).padStart(2, '0');

    const yyyy = currentDate.getFullYear();
    const combineDate = `${yyyy}-${mm}-${dd}T${hours}:${minutes}:${seconds}`;
    this._getModalAddBtnEl.style.display = 'block';
    this._getModalUpdateBtnEl.style.display = 'none';
    this._myModal.show();
    this._getModalStartDateEl.value = combineDate;
    this._getModalEndDateEl.value = combineDate;
  };

  _modalEventClick(eventObj) {
    const getModalEventId = eventObj.event._def.publicId;
    const getModalEventLevel = eventObj.event._def.extendedProps['calendar'];
    const getModalCheckedRadioBtnEl = document.querySelector(
      `input[value="${getModalEventLevel}"]`
    );

    this._getModalTitleEl.value = eventObj.event.title;
    this._getModalStartDateEl.value = eventObj.event.startStr.split('+')[0];
    this._getModalEndDateEl.value = eventObj.event.endStr.split('+')[0];
    this._getModalUrlEl.value = eventObj.event.url;
    getModalCheckedRadioBtnEl.checked = true;
    this._getModalUpdateBtnEl.setAttribute(
      'data-fc-event-public-id',
      getModalEventId
    );
    this._getModalAddBtnEl.style.display = 'none';
    this._getModalUpdateBtnEl.style.display = 'block';
    this._myModal.show();
  }

  _calendarEventClick = info => {
    const self = this;
    const dropdownMenu = document.querySelector('.event-menu');
    const eventLink = document.querySelector('.event-link');

    dropdownMenu.style.setProperty(
      'left',
      `${info.jsEvent.pageX}px`,
      'important'
    );
    dropdownMenu.style.setProperty(
      'top',
      `${info.jsEvent.pageY}px`,
      'important'
    );

    if (!info.event.url) {
      eventLink.style.display = 'none';
    } else {
      eventLink.style.display = 'block';
    }

    dropdownMenu.classList.toggle('show');

    dropdownMenu.addEventListener('click', function (e) {
      const target = e.target;

      if (target.classList.contains('event-edit')) {
        e.preventDefault();
        self._modalEventClick(info);
      } else if (target.classList.contains('event-delete')) {
        e.preventDefault();
        self._toggleDeleteModal(info);
      } else if (target.classList.contains('event-link')) {
        if (info.event.url) window.open(info.event.url);
        info.jsEvent.preventDefault();
      }
    });

    document.addEventListener('click', outsideClickHandler);

    function outsideClickHandler(e) {
      if (!info.el.contains(e.target)) {
        dropdownMenu.classList.toggle('show');
        document.removeEventListener('click', outsideClickHandler);
      }
    }
  };

  _toggleDeleteModal(info) {
    const modalBtn = document.querySelector('#deleteConformation');
    if (modalBtn) {
      const self = this;
      $(modalBtn).modal('show');
      const eventDeleteBtn = document.querySelector('[data-remove="event"]');

      eventDeleteBtn.addEventListener('click', async function (e) {
        e.preventDefault();
        try {
          const eventId = info.event._def.publicId;
          await Database.deleteItemFromDatabase(eventId, 'event');
          info.event.remove();
          self.successMessageInfo(ITEMSDELETED);
        } catch (err) {
          self.failedMessageInfo(FAILEDMESSAGE);
        } finally {
          $(modalBtn).modal('hide');
        }
      });
    }
  }

  _activateCalendar() {
    const self = this;
    this._calendar = new FullCalendar.Calendar(this._calendarEl, {
      selectable: true,
      dayMaxEvents: true,
      height: self._checkWidowWidth() ? 900 : 1052,
      initialView: self._checkWidowWidth() ? 'listWeek' : 'dayGridMonth',
      initialDate: new Date(),
      headerToolbar: self._calendarHeaderToolbar,
      events: self._calendarEventsList,
      select: self._calendarSelect,
      plugins: [timeGridPlugin, dayGridPlugin, interactionPlugin, listPlugin],
      unselect: function () {},
      customButtons: {
        addEventButton: {
          text: 'Add Event',
          click: self._calendarAddEvent,
        },
      },
      //   eventDidMount: function (info) {
      //     tippy(info.el, {
      //       content: info.event.title,
      //       placement: 'bottom',
      //       arrow: true,
      //       animation: 'scale',
      //       theme: 'custom-theme',
      //     });
      //   },
      eventClick: function (info) {
        info.jsEvent.preventDefault();
        self._calendarEventClick(info);
      },
      eventClassNames: function ({ event: calendarEvent }) {
        const getColorValue =
          self._calendarsEvents[calendarEvent._def.extendedProps.calendar];
        return [
          // Background Color
          'event-fc-color fc-bg-' + getColorValue,
        ];
      },

      //   eventClick: self._calendarEventClick,
      windowResize: function (arg) {
        if (self._checkWidowWidth()) {
          self._calendar.changeView('listWeek');
          self._calendar.setOption('height', 900);
        } else {
          self._calendar.changeView('dayGridMonth');
          self._calendar.setOption('height', 1052);
        }
      },
    });
  }

  _validateInput() {
    const startDate = new Date(this._getModalStartDateEl.value);
    const endDate = new Date(this._getModalEndDateEl.value);
    const validationField = document.querySelectorAll('.validation-text');
    const UrlInput = this._getModalUrlEl.value;
    const title = this._getModalTitleEl.value;

    let isValid = true;

    if (startDate > endDate) {
      validationField[2].innerHTML =
        'Start date cannot be greater than end date.';
      validationField[2].style.display = 'block';
      isValid = false;
    } else {
      validationField[2].style.display = 'none';
    }

    if (title === '') {
      validationField[0].innerHTML = 'Enter an Event Title.';
      validationField[0].style.display = 'block';
      isValid = false;
    } else {
      validationField[0].style.display = 'none';
    }

    if (UrlInput !== '') {
      try {
        new URL(UrlInput);
        isValid = true;
        validationField[1].style.display = 'none';
      } catch (error) {
        validationField[1].innerHTML = 'Enter a Valid Url';
        validationField[1].style.display = 'block';
        isValid = false;
      }
    }

    return isValid;
  }

  _addEvent() {
    const self = this;
    this._getModalAddBtnEl.addEventListener('click', async function (event) {
      event.preventDefault();
      try {
        if (!self._validateInput()) return;

        const data = Model.createEvent();

        await Database.addItemtoDatabase(data, 'event');
        self._calendar.addEvent(data);
        self.successMessageInfo(EVENTSUCCESS);
        self._myModal.hide();
      } catch (err) {
        self.failedMessageInfo(FAILEDMESSAGE);
      }
    });
  }

  _updateEvent() {
    const self = this;

    this._getModalUpdateBtnEl.addEventListener('click', async function () {
      try {
        const getPublicID = this.dataset.fcEventPublicId;
        const getEvent = self._calendar.getEventById(getPublicID);

        const data = Model.createEvent(true, getPublicID);
        await Database.updateItemInDatabase(getPublicID, 'event', data);

        getEvent.setProp('title', data.title);
        getEvent.setStart(data.start);
        getEvent.setEnd(data.end);
        getEvent.setProp('url', data.url);
        getEvent.setExtendedProp('calendar', data.extendedProps.calendar);

        self.successMessageInfo(SUCCESSUPDATE);
      } catch (err) {
        self.failedMessageInfo(FAILEDMESSAGE);
      } finally {
        self._myModal.hide();
      }
    });
  }

  _clearModalContent() {
    const self = this;
    document
      .getElementById('exampleModal')
      .addEventListener('hidden.bs.modal', function (event) {
        const validationField = document.querySelectorAll('.validation-text');
        self._getModalTitleEl.value = '';
        self._getModalStartDateEl.value = '';
        self._getModalEndDateEl.value = '';
        self._getModalUrlEl.value = '';
        const getModalIfCheckedRadioBtnEl = document.querySelector(
          'input[name="event-level"]:checked'
        );
        if (getModalIfCheckedRadioBtnEl !== null) {
          getModalIfCheckedRadioBtnEl.checked = false;
        }
        validationField.forEach(text => (text.style.display = 'none'));
      });
  }
}

new CalendarApp();
